import React, { useEffect, useState } from 'react';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import FormFaqAccordion from '../formFaqAccordion/formFaqAccordion';

const Question1 = props => {
  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <h3 className={`${styles.pageTitle}`}>
          First, we need to check the death has been registered
        </h3>
        <h4 className={styles.question}>Has the death been registered or a death certificate issued?</h4>
        <p className={styles.questionText}>
        We need to match the details you provide against Australian death records so the death needs to have been registered or the death certificate issued.
        </p>

        <fieldset className={`nsw-form-fieldset`}>
          <RadioButtonList
            list={[
              {
                value: 'yes',
                label: 'Yes',
                checked:
                  props.birthCertificateIssued && props.birthCertificateIssued === 'yes'
                    ? true
                    : false,
              },
              {
                value: 'no',
                label: 'No',
                checked:
                  props.birthCertificateIssued && props.birthCertificateIssued === 'no'
                    ? true
                    : false,
              },
            ]}
            id={'deceasedDeathCertificate'}
            name={'deceasedDeathCertificate'}
            displayLayout={'horizontal'}
            handleChange={(item, name) => {
              if (item.value === 'no') {
                props.setCertificateLongNum(null);
                props.setCertificateShortNum(null);
              }

              props.setBirthCertificateIssued(item.value);
            }}
          />
        </fieldset>
        {props.birthCertificateIssued === 'no' ? (
          <FormFaqAccordion
            title={`The death hasn’t been registered`}
            icon={`Support_troubleshooting.svg`}
            text={`<p>The death needs to have been registered or the death certificate issued before the service can be used.</p>          <p>Please visit the website of the relevant state's Registry if you need to obtain a replacement or register a death:</p><ul><li><a href=\"https://www.qld.gov.au/law/births-deaths-marriages-and-divorces/birth-death-and-marriage-certificates/death-certificates/applying-for-a-death-certificate\" target=\"_blank\">QLD</a></li>          <li><a href=\"https://www.wa.gov.au/service/justice/civil-law/apply-death-certificate\" target=\"_blank\">WA</a></li><li><a href=\"https://www.nsw.gov.au/family-and-relationships/deaths/death-certificates\" target=\"_blank\">NSW</a></li><li><a href=\"https://www.bdm.vic.gov.au/access/death-information\" target=\"_blank\">VIC</a></li><li><a href=\"https://www.sa.gov.au/topics/family-and-community/births-deaths-and-marriages/certificates/death-certificates\" target=\"_blank\">SA</a></li><li><a href=\"https://www.justice.tas.gov.au/bdm/applyforcertificate\" target=\"_blank\">TAS</a></li><li><a href=\"https://nt.gov.au/law/bdm/apply-for-birth-death-or-marriage-certificate\" target=\"_blank\">NT</a></li>          <li><a href=\"https://www.accesscanberra.act.gov.au/s/article/apply-for-a-birth-death-or-marriage-certificate-tab-how-to-apply-for-a-death-certificate\" target=\"_blank\">ACT</a></li></ul>`}
          ></FormFaqAccordion>
        ) : null}
        <div className={styles.btnWrap}>
          <Button
            disabled={props.birthCertificateIssued !== 'yes'}
            onClick={() => {
              props.setCurrentQuestion(2);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question1;
